//@ts-nocheck

"use client";

import React from "react";
import { useRouter } from "next/navigation";

import * as S from "./ErrorPage.styles";
import { theme } from "../../../theme";
import { Container } from "../../atoms/GridSystem";
import Button from "../../atoms/Button/Button.component";
import { useTranslations } from "next-intl";

interface ErrorPageInterface {
  title: string;
  image: {
    src: string;
    alt: string;
  };
}

const ErrorPage: React.FC<ErrorPageInterface> = ({ title, image }) => {
  const router = useRouter();
  const t = useTranslations();

  const NOT_FOUND_CONTENT = {
    title: t("404.title"),
    buttonText: t("404.ctaLabel"),
  };
  return (
    <S.ErrorPage>
      <S.StyledLeafShape imageShape="leaf" color={theme.palette.green[200]} />
      <S.StyledCircleShape
        imageShape="circle"
        color={theme.palette.green[50]}
      />
      <Container>
        <S.ErrorPageContainer>
          <S.ErrorPageContent>
            <S.ImageContainer>
              <img src={image.src} alt={image.alt} />
            </S.ImageContainer>
            <S.StyledHeading typo="headingMD">{title}</S.StyledHeading>
          </S.ErrorPageContent>
          <S.ErrorPageCTA>
            <Button
              variant="secondary"
              label={NOT_FOUND_CONTENT.buttonText}
              iconEnd="arrow-right"
              href={"/"}
            />
          </S.ErrorPageCTA>
        </S.ErrorPageContainer>
      </Container>
    </S.ErrorPage>
  );
};

export default ErrorPage;
